import { acquireToken } from "@/config/authConfig";
import SpinLoader from "@/containers/Layout/MainLayout/SpinLoader";
import { InteractionType } from "@azure/msal-browser";
import { useAccount, useMsal, useMsalAuthentication } from "@azure/msal-react";
import { ReactNode, useEffect, useState } from "react";

type AuthWrapperProps = {
  children: ReactNode;
};

export const AuthWrapper = ({ children }: AuthWrapperProps) => {
  useMsalAuthentication(InteractionType.Redirect);
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] ?? null);
  const [tokenReady, setTokenReady] = useState(false);

  useEffect(() => {
    if (!account) {
      setTokenReady(false);
      return;
    }

    let cancelled = false;

    const loadToken = async () => {
      const applicationId = instance.getConfiguration().auth.clientId;
      const acquireResult = await acquireToken(account, instance, applicationId);

      if (!cancelled && acquireResult.silent) {
        setTokenReady(true);
      }
    };

    void loadToken();

    return () => {
      cancelled = true;
    };
  }, [account, instance]);

  if (!tokenReady) {
    return <SpinLoader />;
  }

  return <>{children}</>;
};
